export const carrierPermissions = {
    VIEW_CARRIERS: {
        key: 'carriers.view',
        name: 'View carriers'
    },
    EDIT_CARRIERS: {
        key: 'carriers.edit',
        name: 'Edit carriers'
    }
};